export default __webpack_public_path__ + "static/media/PublicisSapient.93bee978.png";